import type { DeleteAlbumTarget } from '../hooks/use-album-mutations'

export interface DeleteAlbumModalProps {
  target: DeleteAlbumTarget
  confirmText: string
  loading: boolean
  onConfirmTextChange: (text: string) => void
  onConfirm: () => void
  onClose: () => void
}

// Typed-name confirmation for non-empty albums (SOL-141). The confirm button
// stays disabled, and Enter is a no-op, until `confirmText` matches
// `target.name` character for character — see the module doc on
// useAlbumMutations for why empty and non-empty albums need different gates.
export default function DeleteAlbumModal({
  target,
  confirmText,
  loading,
  onConfirmTextChange,
  onConfirm,
  onClose,
}: DeleteAlbumModalProps) {
  return (
    <div className="modal-overlay" onClick={() => !loading && onClose()}>
      <div className="modal-content rename-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Delete album</h3>
        <p>
          This permanently deletes <strong>{target.name}</strong> and all{' '}
          {target.count} {target.count === 1 ? 'photo' : 'photos'} in it.
          This cannot be undone.
        </p>
        <p>
          Type <strong>{target.name}</strong> to confirm.
        </p>
        <div className="rename-input-wrapper">
          <input
            type="text"
            value={confirmText}
            onChange={(e) => onConfirmTextChange(e.target.value)}
            placeholder={target.name}
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !loading && confirmText === target.name) {
                onConfirm()
              }
              if (e.key === 'Escape' && !loading) onClose()
            }}
          />
        </div>
        <div className="modal-actions">
          <button
            onClick={onConfirm}
            className="primary-button album-delete-confirm-btn"
            disabled={loading || confirmText !== target.name}
          >
            {loading ? 'Deleting…' : 'Delete album'}
          </button>
          <button onClick={onClose} disabled={loading}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
